import React, { useEffect, useState } from "react";
import { useAuthContext } from "../hooks/useAuthContext";

//firebase imports
import { db, auth, facebookProvider } from "../firebase/config";
import { signInWithPopup, updateProfile } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export const useSignInWithFacebook = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();

  const signInWithFacebook = async () => {
    setError(null);
    setIsPending(true);

    try {
      const res = await signInWithPopup(auth, facebookProvider);
      // console.log("fb res", res);
      // update the user's display name in their profile
      const prof_res = await updateProfile(res.user, {
        displayName: res.user.displayName,
      });
 
      dispatch({ type: "LOGIN", payload: res.user });

      // set the state
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }

      // send them to the home page
      navigate("/");
    } catch (err) {
      // console.log("error:", err.message);

      // set the state
      if (!isCancelled) {
        setIsPending(false);
        setError(err.message);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { error, isPending, signInWithFacebook };
};

export default useSignInWithFacebook;
